<!-- 库存智能预警 -->
<template>
  <div>
    <matrix-statistics span="6" :list="statisticsList"></matrix-statistics>
    <el-card style="margin-bottom: 20px;">
      <div class="title" style="margin-bottom: 10px;">
        <p></p>
        <div>
          <el-input v-model="input" placeholder="搜索货主" style="width: 160px;"></el-input>
          <el-input v-model="input" placeholder="搜索物质名称" style="width: 160px;margin-left: 16px;"></el-input>
          <el-select v-model="value1" placeholder="预警等级" style="width: 160px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value1" placeholder="处理状态" style="width: 160px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
          <el-button type="success" style="margin-left: 16px;width: 98px;">批量处理</el-button>
        </div>
      </div>
      <avue-crud :data="data" :option="option" :page.sync="page" class="penetrate">
        <template slot-scope="scope" slot="name5">
          <matrix-tag v-if="scope.row.name5 == 0" color="#F97316" text="余额不足"></matrix-tag>
          <matrix-tag v-if="scope.row.name5 == 1" color="#DC2626" text="已完成"></matrix-tag>
        </template>
         <template slot-scope="scope" slot="name7">
           <el-link :underline="false">待处理</el-link>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text">处理</el-button>
          <el-button type="text">详情</el-button>
        </template>
      </avue-crud>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>

<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag'
export default {
  name: "store-management/index/index",
  components: {
    matrixStatistics,
    matrixTag
  },
  data() {
    return {
      input: '',
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      statisticsList: [{
        label: '总预警数',
        value: 156,
        icon: 'el-icon-message-solid',
        iconColor: '#2563EB'
      }, {
        label: '欠费预警',
        value: 89,
        subhead: '禁止出厂',
        icon: 'el-icon-warning',
        iconColor: '#F97316'
      }, {
        label: '余额不足预警',
        value: 67,
        subhead: '需要续费提醒',
        icon: 'el-icon-s-opportunity',
        iconColor: '#DC2626'
      }, {
        label: '超量预警',
        value: 68,
        subhead: '需要核查库存',
        icon: 'el-icon-error',
        iconColor: '#DC2626'
      }],

      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '深圳市科技有限公司',
        name2: '工业级氧化铝',
        name3: '2,890 kg',
        name4: '￥8,500',
        name5: 0,
        name6: '2023-12-01 14:30',
        name7: 0
      }, {
        name1: '广州化工材料公司',
        name2: '高纯度硫酸',
        name3: '1,200 L',
        name4: '￥3,200',
        name5: 1,
        name6: '2023-12-01 16:45',
        name7: 0
      }, {
        name1: '东莞精密制造厂',
        name2: '工业乙醇',
        name3: '5,600 L',
        name4: '￥12,800',
        name5: 0,
        name6: '2023-12-01 09:15',
        name7: 0
      }, {
        name1: '珠海新材料科技',
        name2: '电子级丙酮',
        name3: '800 L',
        name4: '￥2,500',
        name5: 0,
        name6: '2023-12-01 11:20',
        name7: 0
      }],
      option: {
        header: false,
        editBtn: false,
        delBtn: false,
        menuWidth: '120px',
        height: '370px',
          searchLabelWidth: 0,

        column: [{
          label: '货主',
          prop: 'name1',
          align: 'center',
          width: 150,
          search: true,
          searchLabel: ''
        }, {
          label: '物质名称',
          prop: 'name2',
          align: 'center',
                search: true,
          searchLabel: '',
          searchLabelWidth: 0,

        }, {
          label: '当前库存量',
          prop: 'name3',
          align: 'center'
        }, {
          label: '押金余额',
          prop: 'name4',
          align: 'center'
        }, {
          label: '预警等级',
          prop: 'name5',
          align: 'center'
        }, {
          label: '触发时间',
          prop: 'name6',
          align: 'center',
          width: 140
        }, {
          label: '状态',
          prop: 'name7',
          align: 'center'
        }]
      },
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
